import {LABELS} from '@github-ui/item-picker-base/constants/labels'
import {GitBranchIcon, TriangleDownIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {forwardRef} from 'react'

export type DefaultBranchPickerAnchorProps = {
  branchName?: string
  readonly?: boolean
} & React.HTMLAttributes<HTMLElement>

export const DefaultBranchPickerAnchor = forwardRef<HTMLButtonElement, DefaultBranchPickerAnchorProps>(
  ({branchName, readonly, ...anchorProps}, branchPickerRef) => (
    <Button
      leadingVisual={GitBranchIcon}
      trailingVisual={TriangleDownIcon}
      aria-label={!anchorProps?.['aria-labelledby'] ? LABELS.selectBranch : undefined}
      disabled={readonly}
      {...anchorProps}
      ref={branchPickerRef}
    >
      {branchName ? <span>{branchName}</span> : LABELS.selectBranch}
    </Button>
  ),
)

DefaultBranchPickerAnchor.displayName = 'DefaultBranchPickerAnchor'
